import { Injectable } from "@angular/core";
import { BaseEntityService } from "./rest-common.service";
import { HttpClient } from "@angular/common/http";


@Injectable({
  providedIn: "root",
})

export class ContractService extends BaseEntityService {

  public resource_url = `${this.BASE_API_URL}/msa-contract/`;

  constructor(
    public http: HttpClient
  ) {
    super();
  }

  viewFile(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/view-contract`, '', params);
    return this.get(url)
  }

  uploadFile(data) {
    let url = `${this.resource_url}upload/`;
    return this.post(url, data);
  }

}

@Injectable({
  providedIn: "root",
})

export class SignContractService extends BaseEntityService {

  public resource_url = `${this.BASE_API_URL}/signed-msa/`;

  constructor(
    public http: HttpClient
  ) {
    super();
  }

}
